export default __webpack_public_path__ + "static/media/mobile_beehive_status_en.d8655954.png";